import React from 'react'
import styles from './FirstView.module.css'

export default function FirstView() {
    return (
        <section id='fv' className={styles.firstView}>
            <header>
                <img
                    src={`/pages/business/foodstadium/logo_white.svg`}
                    alt='FoodsLaboのロゴ'
                />
            </header>
            <div className={styles.fvBg}>
                <div className={styles.fvBox}>
                    <div className={styles.fvCatchphrase}>
                        <img
                            src={`/pages/business/foodstadium/fv_catchphrase.svg`}
                            alt='採用決定までコスト0円の採用DXプラットフォーム'
                        />
                    </div>
                    <div className={styles.fvSpMockup}>
                        <img
                            src={`/pages/business/foodstadium/fv_mockup.png`}
                            alt='FoodsLaboの画面'
                        />
                    </div>
                    <div className={styles.fvCollaborativetextBox}>
                        <img
                            src={`/pages/business/foodstadium/fv_collaborativetext.png`}
                            alt='飲食正社員採用の『今』を変える！注目のコラボ誕生！'
                        />
                        <div>
                            <a href='#form'>フーズラボのお問い合わせはこちら</a>
                        </div>
                    </div>
                </div>
                <div
                    className={styles.fvBoxPc}
                    style={
                        {
                            '--bg-url': `url('/pages/business/foodstadium/fv_mockup.png')`,
                        } as React.CSSProperties
                    }
                    aria-hidden
                />
            </div>
        </section>
    )
}
